<!--国家信息-->
<template>
  <Page class="queryView" :breadCrumb="breadCrumb">
    <div>
      <div class="pageContent-title">领区列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addRow">
          <app-icon type="icon-tianjia"></app-icon>
          添加领区
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="useRowIndex"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
    <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk">
      <a-form labelAlign="left" class="flex-form form-label-5" :form="modal.form">
        <a-form-item label="设置领区">
          <a-input
            v-decorator="[
              'regionName',
              {
                rules: [{ required: true, message: '请输入' }],
              },
            ]"
            autocomplete="off"
            placeholder="请输入领区"
          ></a-input>
        </a-form-item>
        <!-- {{ modal.form.getFieldValue('provinceId') }}{{352}} -->
        <a-form-item label="选择省份" class="select-province">
          <a-select class="flex-1 mr-1" v-decorator="['provinceId']" placeholder="请选择省份，可多选" :options="regionList" mode="multiple">
          </a-select>
          <a-button type="primary" @click="selectAll">全选</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '8%',
        align: 'center',
        // dataIndex: 'userName',
        customRender: (text, row, index) => {
          return <div>{index + 1}</div>
        },
      },
      {
        title: '领区',
        width: '12%',
        align: 'center',
        dataIndex: 'consularRegionName',
      },
      {
        title: '省份',
        align: 'center',
        dataIndex: 'provinceList',
        customRender: text => {
          return (
            <span>
              {text?.map((item, index) => {
                const sep = index === 0 ? '' : '、'
                return sep + item.regionName
              })}
            </span>
          )
        },
      },
      {
        title: '操作',
        width: '10%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-5 justify-center items-center text-primary-500">
              <span
                style="cursor:pointer"
                onClick={() => {
                  this.editRow(row)
                }}
              >
                修改
              </span>
              <span
                style="cursor:pointer"
                onClick={() => {
                  this.removeRow(row)
                }}
              >
                删除
              </span>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      tableLoading: false,
      tableColumns: tableColumns,
      modal: {
        visible: false,
        title: '',
        form: this.$form.createForm(this),
        data: {},
      },
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      dataSource: [],
      regionList: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {}
    },
  },
  async mounted() {
    this.doQuery()
    try {
      const res = await this.$axios.get('/auxiliary/admin/region', {
        params: {
          page: 1,
          limit: 1000,
          level: 1,
        },
      })
      this.regionList = res.data.map(item => {
        return {
          label: item.shortname,
          value: item.regionId,
          text: item.shortname,
        }
      })
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    breadCrumb(list) {
      return [...list, '设置领区']
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/visa/admin/consular/region', {
          params: {
            countryId: this.$route.query.countryId,
          },
        })
        this.countTotal = Number(res.count)
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    addRow() {
      this.resetModal$t()
      this.modal.title = '新增领区'
      this.modal.visible = true
    },
    editRow(row) {
      this.resetModal$t()
      this.modal.title = '修改领区'
      this.modal.visible = true
      this.modal.data = { ...row }
      this.safeSetFieldsValue$t(this.modal.form, {
        regionName: row.consularRegionName,
        provinceId: row.provinceList?.map(item => item.regionId),
      })
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            await this.$axios.post('/visa/admin/consular/region', {
              consularRegionId: this.modal.data.consularRegionId,
              consularRegionName: params.regionName,
              countryId: this.$route.query.countryId,
              provinceList: params.provinceId?.map(provinceId => {
                const province = {
                  regionId: provinceId,
                  regionName: '',
                }
                const regionProvince = this.regionList.find(item => item.value === provinceId)
                if (regionProvince) {
                  province.regionName = regionProvince.label
                }

                return province
              }),
            })
            this.$message.success('操作成功!')
            this.modal.visible = false
            this.doQuery()
          } catch (e) {
            console.error(e)
          }
        }
      })
    },

    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.delete(`/visa/admin/consular/region/${row.consularRegionId}`)
      this.$message.success('操作成功!')
      this.doQuery()
    },
    selectAll() {
      const selected = this.modal.form.getFieldValue('provinceId') || []
      // 只要包含未被选中的
      const shouldSelectAll = this.regionList.some(item => !selected.includes(item.value))
      this.safeSetFieldsValue$t(this.modal.form, {
        provinceId: shouldSelectAll ? this.regionList.map(item => item.value) : [],
      })
    },
  },
}
</script>

<style lang="less">
.select-province {
  .ant-form-item-children {
    display: flex;
  }
}
</style>
